import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import Navbardeo from "../shared/Navbardeo";
import Sidebardeo from "../shared/Sidebardeo";
import { useLocation, useNavigate } from "react-router-dom";
import Footerdeo from "../shared/Footerdeo";
import Swal from "sweetalert2";
import axios from "axios";
import StudentDetailsModal from "./StudentDetailsModal";
import config from "../../config";

import $ from "jquery";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";

const PendingApplicantsPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [remark, setRemark] = useState("");
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);

  // Loader states for buttons
  const [approveLoading, setApproveLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const location = useLocation();
  const schoolCode = location.state?.school?.schooL_CODE;

  const [searchQuery, setSearchQuery] = useState("");

  const filteredStudents = students.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.candidatE_NAME?.toLowerCase().includes(query) ||
      student.dob?.toLowerCase().includes(query) ||
      student.fatheR_NAME?.toLowerCase().includes(query) ||
      student.motheR_NAME?.toLowerCase().includes(query) ||
      student.candidatE_ID?.toLowerCase().includes(query) ||
      student.deO_STATUS?.toLowerCase().includes(query)
    );
  });

  const navigate = useNavigate();
  // Fetch pending details function (must be reusable)
  const fetchPendingDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/DEOPendingCheckDetails_CL9`,
        {
          deO_ID: sessionStorage.getItem("deoId"),
          schooL_CODE: schoolCode,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("deotoken")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.status === 200) {
        setStudents([]);
        setStudents(response.data.data.deoPending_status || []);
      } else {
        setStudents([]);
        console.error("API error:", response.data.message);
      }
    } catch (error) {
      setStudents([]);
      console.error("Error fetching pending details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (schoolCode) {
      fetchPendingDetails();
    } else if (!schoolCode) {
      navigate("/deo-pending-for-approval");
    }
  }, [schoolCode]);

  const handleApproveSelected = async () => {
    if (selectedIds.length === 0) {
      return Swal.fire("Select at least one student to approve.");
    }

    setApproveLoading(true);

    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to approve the selected candidate(s)?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#7066E0",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Approve",
      cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) {
      setApproveLoading(false);
      return;
    }

    const deoId = sessionStorage.getItem("deoId");
    const candidateIdString = selectedIds.join(",");
    try {
      setLoading(true);

      await axios.post(
        `${config.API_BASE_URL}/PendingUpdateDEOStatusApproRejct_CL9`,
        {
          status: "APPROVED",
          statuS_CHANGE_BY: deoId,
          candidatE_ID: candidateIdString,
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("deotoken")}`,
            "Content-Type": "application/json",
          },
        }
      );

      setLoading(false);

      Swal.fire("Successfully Approved.", "", "success").then(() => {
        window.location.reload();
      });
    } catch (error) {
      setLoading(false);
      console.error("Approval error:", error);
      Swal.fire("Error", "Failed to approve candidates.", "error");
    } finally {
      setApproveLoading(false);
    }
  };

  // View Modal
  const handleModalOpen = async (student) => {
    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/FetchDEODemographyData_CL9`,
        {
          candidatE_ID: student.candidatE_ID,
          schooL_CODE: schoolCode,
          districtcode: sessionStorage.getItem("deoId"),
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("deotoken")}`,
            "Content-Type": "application/json",
          },
        }
      );
      setSelectedStudent(response.data?.data["deoDemography_data"] || {});
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching student demography data:", error);
      Swal.fire("Error", "Failed to fetch demography data", "error");
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedStudent(null);
  };

  // Selection logic
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    if (checked) {
      const allIds = students.map((student) => student.candidatE_ID);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) => {
      const newSelected = prev.includes(id)
        ? prev.filter((cid) => cid !== id)
        : [...prev, id];
      setSelectAll(newSelected.length === students.length);
      return newSelected;
    });
  };

  // Reject logic
  const handleRejectSubmit = async () => {
    if (!remark.trim()) {
      Swal.fire({
        title: "Remarks Required!",
        text: "Please enter your remarks before submitting.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    setRejectLoading(true);

    const deoId = sessionStorage.getItem("deoId");
    const id = selectedIds[0];

    try {
      await axios.post(
        `${config.API_BASE_URL}/PendingUpdateDEOStatusApproRejct_CL9`,
        {
          status: "REJECTED",
          statuS_CHANGE_BY: deoId,
          candidatE_ID: id,
          remarks: remark.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("deotoken")}`,
            "Content-Type": "application/json",
          },
        }
      );

      Swal.fire({
        title: "Successfully Rejected",
        text: "",
        icon: "success",
        confirmButtonText: "OK",
      });

      setShowRejectModal(false);
      setRemark("");
      setSelectedIds([]);
      setSelectAll(false);
      fetchPendingDetails();
    } catch (error) {
      Swal.fire("Error", "Failed to reject the candidate.", "error");
      setShowRejectModal(false);
      setRemark("");
    } finally {
      setRejectLoading(false);
    }
  };

  const handleCloseRejectModal = () => {
    setShowRejectModal(false);
    setRemark("");
    setRejectLoading(false);
  };

  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="container-scroller d-flex flex-column min-vh-100">
        <Navbardeo />
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <div className="container-fluid page-body-wrapper flex-grow-1 d-flex">
          <Sidebardeo />
          <div className="main-panel d-flex flex-column flex-grow-1">
            {/* ======= Content Wrapper ======= */}
            <div className="content-wrapper bg-light flex-grow-1 overflow-auto">
              <div className="container-fluid mt-3 px-4">
                <div className="d-flex justify-content-between align-items-center">
                  <h3>Total Pending Applicants</h3>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        {" "}
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/deo-dashboard");
                          }}
                          style={{ textDecoration: "none", color: "grey" }}
                        >
                          <i
                            className="fa fa-tachometer"
                            style={{ marginRight: "5px" }}
                          ></i>
                          Home
                        </a>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        {" "}
                        Total Pending Applicants
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              {/* ======= Table ======= */}
              <div className="container-fluid px-4">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="d-flex align-items-center">
                        <label htmlFor="rowsPerPage" className="me-2 mb-0">
                          Rows:
                        </label>
                        <select
                          id="rowsPerPage"
                          className="form-select form-select-sm"
                          value={perPage}
                          onChange={handlePerPageChange}
                          style={{ width: "80px" }}
                        >
                          {[10, 20, 50, 100, 500].map((num) => (
                            <option key={num} value={num}>
                              {num}
                            </option>
                          ))}
                        </select>
                      </div>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search..."
                        style={{ width: "200px" }}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>

                    <table
                      id="pendingApplicantsTable"
                      className="table table-bordered table-striped table-sm "
                    >
                      <thead className="table-light justify-center">
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={selectAll}
                            />
                          </th>
                          <th>Sl. No</th>
                          <th>Candidate ID</th>
                          <th>Candidate Name</th>
                          <th>Date of Birth</th>
                          <th>Father's Name</th>
                          <th>Mother's Name</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems?.length > 0 ? (
                          currentItems.map((student, index) => (
                            <tr key={student.candidatE_ID}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedIds.includes(
                                    student.candidatE_ID
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(student.candidatE_ID)
                                  }
                                />
                              </td>
                              <td>{indexOfFirstItem + index + 1}</td>
                              <td>{student.candidatE_ID}</td>
                              <td>{student.candidatE_NAME}</td>
                              <td>{student.dob.split(" ")[0]}</td>
                              <td>{student.fatheR_NAME}</td>
                              <td>{student.motheR_NAME}</td>
                              <td>
                                {student.deO_STATUS === "PENDING" ? (
                                  <span className="badge bg-warning text-dark">
                                    Pending
                                  </span>
                                ) : (
                                  <span className="badge bg-success">
                                    Approved
                                  </span>
                                )}
                              </td>
                              <td>
                                <div>
                                  <button
                                    className="btn btn-primary btn-sm mb-1"
                                    onClick={() => handleModalOpen(student)}
                                  >
                                    View Details
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center py-3">
                              Data not available.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing {(currentPage - 1) * perPage + 1} to{" "}
                        {Math.min(indexOfLastItem, filteredStudents.length)} of{" "}
                        {filteredStudents.length} entries
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <MdOutlineKeyboardDoubleArrowLeft
                          onClick={() => {
                            if (currentPage > 1) setCurrentPage(1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardArrowLeft
                          onClick={() => {
                            if (currentPage > 1)
                              setCurrentPage((prev) => prev - 1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <span>
                          Page {currentPage} of {totalPages}
                        </span>

                        <MdOutlineKeyboardArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage((prev) => prev + 1);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardDoubleArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage(totalPages);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />
                      </div>
                    </div>

                    {/* ======= Buttons ======= */}
                    {currentItems?.length > 0 && (
                      <div className="mt-3 d-flex justify-content-end gap-2">
                        <button
                          className="btn btn-success"
                          onClick={handleApproveSelected}
                          disabled={approveLoading || selectedIds.length === 0}
                        >
                          <>✓ Approve</>
                        </button>

                        <button
                          className="btn btn-danger"
                          onClick={() => {
                            if (selectedIds.length === 0) {
                              return Swal.fire(
                                "Please Select At Least One Candidate."
                              );
                            }
                            if (selectedIds.length !== 1) {
                              return Swal.fire(
                                "Only one student can be rejected at a time."
                              );
                            }
                            setShowRejectModal(true);
                          }}
                          disabled={selectedIds.length === 0}
                        >
                          {rejectLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Rejecting...
                            </>
                          ) : (
                            <>✗ Reject</>
                          )}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {showModal && (
              <StudentDetailsModal
                show={showModal}
                handleClose={handleModalClose}
                studentData={selectedStudent}
              />
            )}

            {showRejectModal && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Rejection Remark</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={handleCloseRejectModal}
                        disabled={rejectLoading}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <div className="mb-3">
                        <label htmlFor="remark" className="form-label">
                          Remark <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          id="remark"
                          rows="3"
                          value={remark}
                          onChange={(e) => setRemark(e.target.value)}
                          placeholder="Enter reason for rejection"
                          disabled={rejectLoading}
                        ></textarea>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        onClick={handleCloseRejectModal}
                        disabled={rejectLoading}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={handleRejectSubmit}
                        disabled={rejectLoading}
                      >
                        {rejectLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Submitting...
                          </>
                        ) : (
                          <>Submit Remark & Reject</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* ======= Fixed Footer ======= */}
            <div className="bg-white shadow-sm">
              <Footerdeo />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingApplicantsPage;
